// Header.js
import React, {useState} from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import Logo from "../assets/images/nav1.svg";
import "../assets/styles/header.css";

const Header = ({ activeLink, setActiveLink }) => {

  const [isNavCollapsed, setIsNavCollapsed] = useState(true);

  const handleNavClick = (section) => {
    setActiveLink(section);
    const element = document.getElementById(section);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    if (!isNavCollapsed) {
      setIsNavCollapsed(true);
    }
  };

  return (
    <header>
      <Navbar
        expand="lg"
        sticky="top"
        style={{
          background: "#06071B",
          boxShadow: "0px -1px 1px 0px #0000001A inset",
          position: "relative",
          height: "auto",
        }}
      >
        <Container>
          <Navbar.Brand onClick={() => handleNavClick("home")} style={{ cursor: "pointer" }}>
            <img
              src={Logo}
              alt="Syncrones Logo"
              style={{ height: "38px", marginLeft: "2px" }}
            />
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            onClick={() => setIsNavCollapsed(!isNavCollapsed)}
            style={{
              border: "none",
              background: "transparent",
              backgroundImage:
                "url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3E%3Cpath stroke='white' stroke-width='2' stroke-linecap='round' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\")",
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              width: "30px",
              height: "30px",
            }}
          />
            <Navbar.Collapse id="basic-navbar-nav" in={!isNavCollapsed}> 
            <Nav className="mx-auto">
              {["home", "services", "about", "techstack", "products"].map((section) => (
                <Nav.Link
                  key={section}
                  onClick={() => handleNavClick(section)}
                  className={`nav-item ${activeLink === section ? "active" : ""}`}
                  style={{ cursor: "pointer" }}
                >
                  {section === "techstack"
                    ? "Tech Stack"
                    : section === "products"
                    ? "Our Clients"
                    : section.charAt(0).toUpperCase() + section.slice(1)}
                </Nav.Link>
              ))}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
